// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__KRTOv","logo":"NavBar_logo__bQAUa","nav-links":"NavBar_nav-links__yp5XP"};